import { z } from 'zod';

export { USER_WORKSPACE_STATE_KEYS } from './userWorkspaceStateKeys.js';

// Workflow steps/graph nodes intentionally contain customer content. Only this
// Regional schema accepts those open objects. Other preferences are unchanged.
export const userWorkspaceStateSchema = z
  .object({
    'copied-steps': z
      .object({
        steps: z.array(z.object({}).passthrough()),
        graph: z.record(z.object({}).passthrough()),
        timestamp: z.string()
      })
      .strict()
      .optional(),
    aiHistory: z.array(z.string()).optional()
  })
  .strict();
